module.exports = __webpack_public_path__ + "img/bj.8ec16f93.png";